import { Box, Icon } from '@hover/blueprint';
import { SlideFade } from '@hover/blueprint/chakra';
import { iChevronLeft, iChevronRight } from '@hover/icons';
import React from 'react';

import { useRenderingContext } from 'src/modules/renderings/hooks';
import { Button } from 'src/shared/components';

interface TrayNavigationButtonProps {
  direction: 'right' | 'left';
  onClick: () => void;
  isOpen: boolean;
  hideButton: boolean;
}

const ANIMATION_CONFIG = {
  ease: 'easeOut',
  duration: 0.35,
};

const TrayNavigationButton = ({
  onClick,
  isOpen,
  direction,
  hideButton,
}: TrayNavigationButtonProps) => {
  const isRight = direction === 'right';
  const icon = isRight ? iChevronRight : iChevronLeft;
  const { trackingData } = useRenderingContext();

  return (
    <Box
      display={{ base: 'none', tablet: hideButton ? 'none' : 'block' }}
      justifyContent={isRight ? 'end' : 'start'}
      left={isRight ? 'unset' : '0px'}
      marginLeft={{ base: 'unset', desktop: isRight ? 'unset' : '-16px' }}
      marginRight={{ base: 'unset', desktop: isRight ? '-16px' : 'unset' }}
      marginTop="-32px"
      position="absolute"
      right={isRight ? '0px' : 'unset'}
      top="50%"
      width={300}
    >
      <SlideFade
        in={isOpen}
        offsetX={isRight ? '20px' : '-20px'}
        offsetY={0}
        transition={{
          enter: { ...ANIMATION_CONFIG, delay: 0.6 },
          exit: ANIMATION_CONFIG,
        }}
      >
        <Button
          backgroundColor="neutral.0"
          fill="minimal"
          label={`move-to-image-${direction}`}
          onClick={onClick}
          optionalTrackingProperties={{
            ...trackingData,
            track_id: 'rendering-product-tray-chevron',
          }}
          paddingY={500}
          shadow="distance300"
          shape="square"
        >
          <Icon color="neutral.900" icon={icon} size="medium" strokeWidth={2} />
        </Button>
      </SlideFade>
    </Box>
  );
};

export { TrayNavigationButton };
